import SelectProjectTicket from './select_project_ticket'
import connect from './connect'

export default connect(SelectProjectTicket)
